// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-CustomTableDemo-CustomTableDemo-module__demoPage--fM7yE {
  padding: 24px;
  background: #f0f2f5;
  height: 100%;
  overflow: auto;
}
.src-pages-CustomTableDemo-CustomTableDemo-module__header--qj4HX {
  margin-bottom: 24px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.src-pages-CustomTableDemo-CustomTableDemo-module__header--qj4HX h1 {
  margin: 0 0 8px 0;
  font-size: 28px;
  color: #1890ff;
}
.src-pages-CustomTableDemo-CustomTableDemo-module__header--qj4HX p {
  margin: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}
.src-pages-CustomTableDemo-CustomTableDemo-module__controls--kZf2A {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.src-pages-CustomTableDemo-CustomTableDemo-module__controlGroup--drcbE {
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.src-pages-CustomTableDemo-CustomTableDemo-module__controlGroup--drcbE h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
}
.src-pages-CustomTableDemo-CustomTableDemo-module__tableWrapper--Uz385 {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 600px;
  margin-bottom: 24px;
}
.src-pages-CustomTableDemo-CustomTableDemo-module__info--Yio_C {
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.src-pages-CustomTableDemo-CustomTableDemo-module__info--Yio_C h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
}
.src-pages-CustomTableDemo-CustomTableDemo-module__info--Yio_C ul {
  margin: 0;
  padding-left: 20px;
  list-style: disc;
}
.src-pages-CustomTableDemo-CustomTableDemo-module__info--Yio_C ul li {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}
.src-pages-CustomTableDemo-CustomTableDemo-module__inactiveRow--FdkXR {
  opacity: 0.6;
  background: #f5f5f5 !important;
}
@media (max-width: 768px) {
  .src-pages-CustomTableDemo-CustomTableDemo-module__demoPage--fM7yE {
    padding: 12px;
  }
  .src-pages-CustomTableDemo-CustomTableDemo-module__controls--kZf2A {
    grid-template-columns: 1fr;
  }
  .src-pages-CustomTableDemo-CustomTableDemo-module__tableWrapper--Uz385 {
    height: 400px;
  }
}
@media (prefers-color-scheme: dark) {
  .src-pages-CustomTableDemo-CustomTableDemo-module__demoPage--fM7yE {
    background: #141414;
  }
  .src-pages-CustomTableDemo-CustomTableDemo-module__header--qj4HX,
  .src-pages-CustomTableDemo-CustomTableDemo-module__controlGroup--drcbE,
  .src-pages-CustomTableDemo-CustomTableDemo-module__tableWrapper--Uz385,
  .src-pages-CustomTableDemo-CustomTableDemo-module__info--Yio_C {
    background: #1f1f1f;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
  .src-pages-CustomTableDemo-CustomTableDemo-module__header--qj4HX h1 {
    color: #177ddc;
  }
  .src-pages-CustomTableDemo-CustomTableDemo-module__header--qj4HX p {
    color: rgba(255, 255, 255, 0.65);
  }
  .src-pages-CustomTableDemo-CustomTableDemo-module__controlGroup--drcbE h3 {
    color: rgba(255, 255, 255, 0.85);
    border-bottom-color: #303030;
  }
  .src-pages-CustomTableDemo-CustomTableDemo-module__info--Yio_C h3 {
    color: rgba(255, 255, 255, 0.85);
  }
  .src-pages-CustomTableDemo-CustomTableDemo-module__info--Yio_C ul li {
    color: rgba(255, 255, 255, 0.65);
  }
  .src-pages-CustomTableDemo-CustomTableDemo-module__inactiveRow--FdkXR {
    background: #262626 !important;
  }
}
/*# sourceMappingURL=CustomTableDemo.module.css.map */`, "",{"version":3,"sources":["webpack://./CustomTableDemo.module.less","webpack://./src/pages/CustomTableDemo/CustomTableDemo.module.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;ACDF;ADIA;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;ACFF;ADHA;EAQI,iBAAA;EACA,eAAA;EACA,cAAA;ACFJ;ADRA;EAcI,SAAA;EACA,0BAAA;EACA,eAAA;ACHJ;ADOA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;ACLF;ADQA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;ACNF;ADEA;EAOI,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,gCAAA;EACA,mBAAA;ACNJ;ADUA;EACE,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;ACRF;ADWA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;ACTF;ADKA;EAOI,kBAAA;EACA,eAAA;EACA,0BAAA;ACTJ;ADAA;EAaI,SAAA;EACA,kBAAA;EACA,gBAAA;ACVJ;ADLA;EAkBM,kBAAA;EACA,0BAAA;EACA,eAAA;ACVN;ADeA;EACE,YAAA;EACA,8BAAA;ACbF;ADiBA;EACE;IACE,aAAA;ECfF;EDkBA;IACE,0BAAA;EChBF;EDmBA;IACE,aAAA;ECjBF;AACF;ADqBA;EACE;IACE,mBAAA;ECnBF;EDsBA;;;;IAIE,mBAAA;IACA,wCAAA;ECpBF;EDuBA;IAEI,cAAA;ECtBJ;EDoBA;IAMI,gCAAA;ECvBJ;ED2BA;IAEI,gCAAA;IACA,4BAAA;EC1BJ;ED8BA;IAEI,gCAAA;EC7BJ;ED2BA;IAMI,gCAAA;EC9BJ;EDkCA;IACE,8BAAA;EChCF;AACF;AACA,qDAAqD","sourcesContent":["// Стили для демо страницы MdmTable\n\n.demoPage {\n  padding: 24px;\n  background: #f0f2f5;\n  height: 100%;\n  overflow: auto;\n}\n\n.header {\n  margin-bottom: 24px;\n  padding: 24px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n  h1 {\n    margin: 0 0 8px 0;\n    font-size: 28px;\n    color: #1890ff;\n  }\n\n  p {\n    margin: 0;\n    color: rgba(0, 0, 0, 0.65);\n    font-size: 14px;\n  }\n}\n\n.controls {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.controlGroup {\n  padding: 16px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n  h3 {\n    margin: 0 0 12px 0;\n    font-size: 16px;\n    color: rgba(0, 0, 0, 0.85);\n    border-bottom: 1px solid #f0f0f0;\n    padding-bottom: 8px;\n  }\n}\n\n.tableWrapper {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  height: 600px;\n  margin-bottom: 24px;\n}\n\n.info {\n  padding: 24px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n  h3 {\n    margin: 0 0 16px 0;\n    font-size: 18px;\n    color: rgba(0, 0, 0, 0.85);\n  }\n\n  ul {\n    margin: 0;\n    padding-left: 20px;\n    list-style: disc;\n\n    li {\n      margin-bottom: 8px;\n      color: rgba(0, 0, 0, 0.65);\n      font-size: 14px;\n    }\n  }\n}\n\n.inactiveRow {\n  opacity: 0.6;\n  background: #f5f5f5 !important;\n}\n\n// Responsive\n@media (max-width: 768px) {\n  .demoPage {\n    padding: 12px;\n  }\n\n  .controls {\n    grid-template-columns: 1fr;\n  }\n\n  .tableWrapper {\n    height: 400px;\n  }\n}\n\n// Темная тема\n@media (prefers-color-scheme: dark) {\n  .demoPage {\n    background: #141414;\n  }\n\n  .header,\n  .controlGroup,\n  .tableWrapper,\n  .info {\n    background: #1f1f1f;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  }\n\n  .header {\n    h1 {\n      color: #177ddc;\n    }\n\n    p {\n      color: rgba(255, 255, 255, 0.65);\n    }\n  }\n\n  .controlGroup {\n    h3 {\n      color: rgba(255, 255, 255, 0.85);\n      border-bottom-color: #303030;\n    }\n  }\n\n  .info {\n    h3 {\n      color: rgba(255, 255, 255, 0.85);\n    }\n\n    ul li {\n      color: rgba(255, 255, 255, 0.65);\n    }\n  }\n\n  .inactiveRow {\n    background: #262626 !important;\n  }\n}\n",".demoPage {\n  padding: 24px;\n  background: #f0f2f5;\n  height: 100%;\n  overflow: auto;\n}\n.header {\n  margin-bottom: 24px;\n  padding: 24px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n.header h1 {\n  margin: 0 0 8px 0;\n  font-size: 28px;\n  color: #1890ff;\n}\n.header p {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n}\n.controls {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n.controlGroup {\n  padding: 16px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n.controlGroup h3 {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  color: rgba(0, 0, 0, 0.85);\n  border-bottom: 1px solid #f0f0f0;\n  padding-bottom: 8px;\n}\n.tableWrapper {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  height: 600px;\n  margin-bottom: 24px;\n}\n.info {\n  padding: 24px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n.info h3 {\n  margin: 0 0 16px 0;\n  font-size: 18px;\n  color: rgba(0, 0, 0, 0.85);\n}\n.info ul {\n  margin: 0;\n  padding-left: 20px;\n  list-style: disc;\n}\n.info ul li {\n  margin-bottom: 8px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n}\n.inactiveRow {\n  opacity: 0.6;\n  background: #f5f5f5 !important;\n}\n@media (max-width: 768px) {\n  .demoPage {\n    padding: 12px;\n  }\n  .controls {\n    grid-template-columns: 1fr;\n  }\n  .tableWrapper {\n    height: 400px;\n  }\n}\n@media (prefers-color-scheme: dark) {\n  .demoPage {\n    background: #141414;\n  }\n  .header,\n  .controlGroup,\n  .tableWrapper,\n  .info {\n    background: #1f1f1f;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  }\n  .header h1 {\n    color: #177ddc;\n  }\n  .header p {\n    color: rgba(255, 255, 255, 0.65);\n  }\n  .controlGroup h3 {\n    color: rgba(255, 255, 255, 0.85);\n    border-bottom-color: #303030;\n  }\n  .info h3 {\n    color: rgba(255, 255, 255, 0.85);\n  }\n  .info ul li {\n    color: rgba(255, 255, 255, 0.65);\n  }\n  .inactiveRow {\n    background: #262626 !important;\n  }\n}\n/*# sourceMappingURL=CustomTableDemo.module.css.map */"],"sourceRoot":""}]);
// Exports
export var demoPage = `src-pages-CustomTableDemo-CustomTableDemo-module__demoPage--fM7yE`;
export var header = `src-pages-CustomTableDemo-CustomTableDemo-module__header--qj4HX`;
export var controls = `src-pages-CustomTableDemo-CustomTableDemo-module__controls--kZf2A`;
export var controlGroup = `src-pages-CustomTableDemo-CustomTableDemo-module__controlGroup--drcbE`;
export var tableWrapper = `src-pages-CustomTableDemo-CustomTableDemo-module__tableWrapper--Uz385`;
export var info = `src-pages-CustomTableDemo-CustomTableDemo-module__info--Yio_C`;
export var inactiveRow = `src-pages-CustomTableDemo-CustomTableDemo-module__inactiveRow--FdkXR`;
export default ___CSS_LOADER_EXPORT___;
